<template>
    <div class="my-loading-wrapper">
        <om-loading
            :visable="true"
            type="whole"
            theme="blue"
        />
    </div>
</template>
<script>
export default {
    name: 'my-loading'
};
</script>
<style lang="scss" scoped>
@import '@/pages/pano-game/variable.scss';
.my-loading-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: $zIndexLevel9;
    //z-index: $zIndexLevelTop;
}
</style>
